import styled from 'styled-components';
import { layout } from '../../../package.json';

interface ContainerAddressRowProps {
  bCheckout?: boolean
}

export const ContainerAddressRow = styled.div<ContainerAddressRowProps>`
  background: #fff;
  display: flex;
  align-items: center;
  flex-direction: row;

  width: 100%;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid var(--primary);
  margin-bottom: 10px;
  transition:all 0.8s ease;

  ${props => props.bCheckout && `
  :hover{
    background-color: var(--primary);

    span {
      color: #FFF;
    }

    p {
      color: #FFF;
    }

    svg{
      color: #FFF;

    }
  }
  cursor: pointer;
  `}
`;

export const AddressSelButton = styled.div`
  cursor: pointer;
  margin-right: 15px;

`;

export const AddressName = styled.div`
  width: 120px;
  margin-right: 15px;
`;

export const ButtonContent = styled.div`
  margin-left: auto;
  display: flex;
`;

export const AddressButton = styled.div`
  margin-left: 10px;
  margin-right: 10px;
  cursor: pointer;
  :hover{
      svg {
      color: var(--btn-finish);
    }
  }
`;

export const ContentCreateAddress = styled.div`
  width: 100%;
`

export const ContentLoading = styled.div`
  width: 100%;
  div{
    margin: 0 auto;
  }
`

export const ContentInfo = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  div + div {
    margin-top: 0.5rem;
  }

  @media (max-width: ${layout.desktop}) {
    flex-direction: column;
    align-items: flex-start;
  }
`